import { mode } from '@chakra-ui/theme-tools';

import { colors } from '../../colors';

// Exports
export const Table = {
  baseStyle: (props: any) => ({
    thead: {
      bg: mode('millet.50', colors.gray['950'])(props),
      color: mode(colors['v2-aurora']['900'], colors['v2-aurora']['50']),
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: '20px',
      textTransform: 'capitalize',
      letterSpacing: 0,
    },
    th: {
      bg: mode('millet.50', colors.gray['950'])(props),
      color: mode(colors['v2-aurora']['900'], colors['v2-aurora']['50']),
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: '20px',
      textTransform: 'capitalize',
      letterSpacing: 0,
    },
  }),
} as const;
